import { Headers, Http } from '@angular/http';

export const URL_API: string = 'https://api.scd.tic.ufrj.br';
export const URL_CAS: string = 'https://cas.ufrj.br';
export const URL_LOGOUT: string = 'http://sgcd.ufrj.br/';
export const PER_PAGE: number = 50;
export const HEADERS: Headers = new Headers({'Accept': 'application/json; text/plain, */*', 'Content-Type': 'multipart/form-data'});



// WEBPACK FOOTER //
// ./src/app/constante.ts